import { createRoot } from 'react-dom/client'
import App from './App.tsx'

// Self-hosted fonts (no external Google Fonts <link>)
import '@fontsource-variable/inter'
import '@fontsource/sora/400.css'
import '@fontsource/sora/600.css'
import '@fontsource/sora/700.css'

import './index.css'

createRoot(document.getElementById("root")!).render(<App />);
